/* eslint-disable no-unused-expressions */
import axios from "axios"
import headers from "../../util/headers"

export const getOrganisations = (baseUrl, params) => {
  const path = `${baseUrl}/backend/organisations`
  return axios.get(path, { params, ...headers() })
    .then(({ data, status, headers: resHeaders }) => ({ response: data, status, headers: resHeaders }))
    .catch(error => { error })
}

export const createOrganisation = (baseUrl, organisation) => {
  const path = `${baseUrl}/backend/organisations`
  return axios.post(path, organisation, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

export const getOrganisationDetail = (baseUrl, organisation_id) => {
  const path = `${baseUrl}/backend/organisations/details`
  return axios.post(path, { params: { id: organisation_id } }, headers())
    .then(({ data, status }) => ({ response: data, status }))
    .catch(error => { error })
}

// export const updateOrganisationDetail = (baseUrl, form) => {
//   const path = `${baseUrl}/backend/organisations/details`
//   return axios.put(path, form, headers())
//     .then(({ data, status }) => ({ response: data, status }))
//     .catch(error => { error })
// }